module.exports = __webpack_public_path__ + "static/media/image.832be3f7.png";